import { FeatureFlagResults } from '@moda/portal-stanchions';

export const setFeatureFlags = (flags?: FeatureFlagResults) => {
  window.__FEATURE_FLAGS__ = flags || {};
};
